module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/apprenticePointingUp2-9c0ac37f7e4a051b551e8d86a6fbf1fb.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/apprenticePointingUp2.png
// module id = 2365
// module chunks = 2